import Termscond from './TermsCond';
import { SIZE } from './constants';

export default Termscond;
export { SIZE };